// extracted by mini-css-extract-plugin
module.exports = {"chip":"e_J8","stat":"e_K8","k":"e_L8","v":"e_M8","scale":"e_N8","text":"e_O8","pills":"e_P8"};